module.exports = __webpack_public_path__ + "static/media/52.f51b6c2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/52.jpg
// module id = 420
// module chunks = 0